import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  select,
} from '@ngrx/store';
import { pipe } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { AllActionsUnion } from '../../../app.actions';
import {
  resetState,
  storeMaintenanceMessage,
  updateUnderMaintenance,
} from './maintenance.actions';

export interface MaintenanceState {
  underMaintenance: boolean;
  maintenanceMessage: string;
}

const initialState: MaintenanceState = {
  underMaintenance: false,
  maintenanceMessage: '',
};

export const featureName = 'maintenanceFeature';

export function maintenanceReducer(
  state_: MaintenanceState | undefined,
  action: AllActionsUnion,
): MaintenanceState {
  const reducer_ = createReducer<MaintenanceState>(
    initialState,
    on(
      updateUnderMaintenance,
      (state, { payload }): MaintenanceState => {
        return { ...state, underMaintenance: payload };
      },
    ),
    on(
      storeMaintenanceMessage,
      (state, { payload }): MaintenanceState => {
        return { ...state, maintenanceMessage: payload };
      },
    ),
    on(
      resetState,
      (): MaintenanceState => {
        return { ...initialState };
      },
    ),
  );
  return reducer_(state_, action);
}

const getFeature = createFeatureSelector<MaintenanceState>(featureName);

export const getUnderMaintenance = pipe(
  select(
    createSelector(
      getFeature,
      v => v.underMaintenance,
    ),
  ),
  distinctUntilChanged(),
);

export const getMaintenanceMessage = pipe(
  select(
    createSelector(
      getFeature,
      v => v.maintenanceMessage,
    ),
  ),
  distinctUntilChanged(),
);
